import * as S from './InputNumber.styled';

export default S.InputNumber;
